import { makeStyles, Theme } from "@material-ui/core/styles";

export default makeStyles((theme: Theme) => ({
  alert: {
    borderRadius: 0,
    zIndex: theme.zIndex.tooltip,
  },
  button: {
    marginLeft: theme.spacing(1),
  },
}));
